/**
 * Labstep
 *
 * @module screens/JupyterNotebook/Show/Right
 * @desc JupyterNotebook Show Right
 */

import { RightPane } from 'labstep-web/components/Layout/RightPane';
import type { RightPaneProps } from 'labstep-web/components/Layout/RightPane/types';
import { LogIndex } from 'labstep-web/screens/Log/Index';
import type React from 'react';
import type { IScreensJupyterNotebookShowRightProps } from './types';

export const ScreensJupyterNotebookShowRight: React.FC<
  IScreensJupyterNotebookShowRightProps
> = ({ jupyterNotebook }) => {
  const subPages: RightPaneProps['subPages'] = [
    {
      name: 'Activity',
      icon: 'history',
      route: {
        to: 'jupyter_notebook_show_activity',
        params: { id: jupyterNotebook.id },
      },
      component: (
        <LogIndex
          entityName={jupyterNotebook.entityName}
          entityId={jupyterNotebook.id}
        />
      ),
    },
  ];

  return (
    <RightPane
      route={{
        to: 'jupyter_notebook_show',
        params: { id: jupyterNotebook.id },
      }}
      subPages={subPages}
    />
  );
};
